import React from "react";
import { useHistory } from "react-router";
import "./style.css";

function OfferCard(props: any) {
  const { properties } = props;
  const {
    offer_amount,
    tenure,
    down_payment,
    processing_fee,
    emi_amount,
    advance_emi,
  } = properties;
  const history = useHistory();
  const historyState: any = history.location.state;
  return (
    <div id="containers">
      <div id="offer_amount">
        <div style={{ fontSize: "15px" }}>Offer Amount</div>
        <div style={{ fontSize: "35px",fontWeight: 600 }}>
          ₹{offer_amount}
        </div>
      </div>

      <div id="offer_details">
        <div className="divsFlex">
          <div>Tenture</div>
          <div style={{ marginLeft: "3.3rem", marginTop: "2px" }}>{tenure}</div>
        </div>

        <div className="divsFlex">
          <div>Down Payment</div>
          <div style={{ marginLeft: "0.5rem" }}>{down_payment}</div>
        </div>

        <div className="divsFlex">
          <div>Processing Fee</div>
          <div style={{ marginLeft: "0.7rem" }}>{processing_fee}</div>
        </div>

        <div className="divsFlex">
          <div>EMI Amount</div>
          <div style={{ marginLeft: "1.5rem" }}>{emi_amount}</div>
        </div>

        <div className="divsFlex">
          <div>Advance EMI</div>
          <div style={{ marginLeft: "1.2rem" }}>{advance_emi}</div>
        </div>
      </div>
    </div>
  );
}

export default OfferCard;
